import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Efficiency } from './components/Efficiency';
import { Showroom } from './components/Showroom';
import { Pricing } from './components/Pricing';
import { Technology } from './components/Technology';
import { Strategy } from './components/Strategy';
import { FooterCTA } from './components/FooterCTA';
export function App() {
  useEffect(() => {
    document.title = 'Winning Ads Factory';
  }, []);
  return <div className="min-h-screen bg-[#050505] selection:bg-[#00E5FF] selection:text-black" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Efficiency data-id="element-3" />
        <Showroom data-id="element-4" />
        <Pricing data-id="element-5" />
        <Technology data-id="element-6" />
        <Strategy data-id="element-7" />
        <FooterCTA data-id="element-8" />
      </main>

      <footer className="bg-black py-8 text-center text-gray-600 text-sm" data-id="element-9">
        <p data-id="element-10">
          © {new Date().getFullYear()} Winning Ads Factory. All rights
          reserved.
        </p>
      </footer>
    </div>;
}